import { useCommonStore } from '@shared/model'
import { runApiWrite } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'

/** `POST /admin-api/subscriptions/{subscription}/sync` — re-pull the subscription and its orders from the provider. */
export const useSubscriptionSync = async (subscriptionId: number): Promise<boolean> => {
  const commonStore = useCommonStore()

  return runApiWrite(useAdminRoutes('admin.subscription.sync', { subscription_id: subscriptionId }), {
    setLoading: commonStore.setLoading,
  })
}
